module.exports = __webpack_public_path__ + "img/TonyPortannese@2x.56925095.png";